import { RefObject, useEffect, useState } from 'react';

export function useResizeObserver (ref: RefObject<HTMLElement>) {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    let observer: ResizeObserver | null = null;
    let interval: NodeJS.Timeout | null = null;

    function attach () {
      if (ref.current && !observer) {
        observer = new ResizeObserver(([entry]) => {
          setHeight(entry.contentRect.height);
        });
        observer.observe(ref.current);
        setHeight(ref.current.getBoundingClientRect().height);
      }
    }
    attach();
    if (!ref.current) {
      interval = setInterval(() => {
        attach();
        if (ref.current && observer) {
          clearInterval(interval!);
        }
      }, 50);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [ref]);

  return height;
}
